var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "footer {\n  background: #252c2d;\n  color: #fefefe;\n  padding: 0; }\n  footer .footer-nav {\n    padding: 60px; }\n    @media (max-width: 768px) {\n      footer .footer-nav {\n        text-align: center; } }\n  footer .footer-box {\n    width: 200px;\n    margin: auto; }\n  footer .footer-title {\n    font-size: 22px;\n    font-weight: 600; }\n  footer .footer-link {\n    font-size: 14px; }\n    footer .footer-link svg {\n      color: #ddfcff; }\n    footer .footer-link a {\n      color: #fefefe;\n      margin-left: 10px;\n      opacity: .8; }\n      footer .footer-link a:hover {\n        text-decoration: underline; }\n  footer .footer-rights {\n    color: rgba(255, 255, 255, 0.2);\n    width: 100%;\n    margin-top: 30px;\n    border-top: 1px solid;\n    padding: 40px 0; }\n    footer .footer-rights .logo {\n      background-image: url(" + escape(require("../../../assets/image/corpo-leve-white.png")) + ");\n      width: 160px;\n      height: 160px;\n      background-position: center;\n      background-size: cover;\n      background-repeat: no-repeat;\n      margin: auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/corpo-leve-www/www/src/app/elements/footer/footer.component.scss
// module id = ../../../../../src/app/elements/footer/footer.component.scss
// module chunks = main